import React, { useState } from 'react';
import { Tabs } from 'antd';
import KnowYourRole from '../../Dashboard/Clan/knowYourRole/knowYourRole';
import { useLocation, useNavigate } from "react-router-dom";
import ContentLibrary from '../../Dashboard/Clan/knowYourRole/ContentLibrary/contentLibrary';
import ProductUpdatesAdmin from '../../Dashboard/Clan/knowYourRole/productUpdates';
import AdminStars from './adminStars';
import AdminContentLibrary from './adminContentLibrary';

const AdminKnowYourTabs = () => {
    const { TabPane } = Tabs;
    const [activeTab, setActiveTab] = useState('1');

    const handleTabChange = (key) => {
        setActiveTab(key);
    };

    const navigate = useNavigate();
    const location = useLocation();
    const name = location.state?.name;
    const accountName = location.state?.accountName;

    const dartsFormNeeded = location.state?.dartsFormNeeded;
    const pocName = location.state?.pocName;
    const pocEmail = location.state?.pocEmail;
    const pocNumber = location.state?.pocNumber;
    const numberLogin = location.state?.numberLogin;
    const emailLogin = location.state?.emailLogin;
    const mandatoryTimeDistribution = location.state?.mandatoryTimeDistribution;
    const targetEditDays = location.state?.targetEditDays;
    const inputEditDays = location.state?.inputEditDays;
    const dartsNeeded = location.state?.dartsNeeded;
    const clanNeeded = location.state?.clanNeeded;
    const syncNeeded = location.state?.syncNeeded;
    const roleId = location.state?.roleId;
    const accountId = location.state?.accountId;

    const [inputType, setInputType] = useState(null);


    const handleBackToViewRole = () => {
        navigate("/admin-view-role", {
            state: {
                roleId: roleId || location.state?.roleId,
                accountId: accountId || location.state?.accountId,
                accountName: accountName || location.state?.accountName,
                name: name || location.state?.name,
                dartsNeeded: inputType ? true : dartsNeeded || location.state?.dartsNeeded, // Update based on inputType
                clanNeeded: clanNeeded || location.state?.clanNeeded,
                syncNeeded: syncNeeded || location.state?.syncNeeded,
                dartsFormNeeded: inputType === "Forms" || dartsFormNeeded || location.state?.dartsFormNeeded,
                pocName: pocName || location.state?.pocName,
                pocEmail: pocEmail || location.state?.pocEmail,
                pocNumber: pocNumber || location.state?.pocNumber,
                numberLogin: numberLogin || location.state?.numberLogin,
                emailLogin: emailLogin || location.state?.emailLogin,
                mandatoryTimeDistribution: mandatoryTimeDistribution || location.state?.mandatoryTimeDistribution,
                targetEditDays: targetEditDays || location.state?.targetEditDays,
                inputEditDays: inputEditDays || location.state?.inputEditDays,
            },
        });
    };

    return (
        <div className="user-management-container" >
            <div style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
            }}>
                <div>
                    <span
                        className="bold-text"
                        style={{ cursor: "pointer" }}
                    >
                        <span onClick={() => navigate("/admin-home")}>{accountName}</span> <span> &gt; </span> <span onClick={handleBackToViewRole}>{name}</span> <span> &gt; </span>
                        <span style={{ fontWeight: "bold" }}>Clan</span>
                    </span>
                </div>

                <button
                    onClick={() => navigate("/admin-home")}
                    style={{
                        padding: "13px 20px",
                        borderRadius: "5px",
                        border: "1px solid #D32F2F",
                        cursor: "pointer",
                        color: "#D32F2F",
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "8px", // slightly wider gap for readability
                        fontSize: "14px", // ensure consistent text size
                        lineHeight: "1" // align with icon
                    }}
                >

                    Back to home
                </button>
            </div>

            <Tabs
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', }}
                activeKey={activeTab}
                onChange={handleTabChange}
            // className="main-tabs"
            >
                <TabPane
                    tab={<span style={{ color: activeTab === '1' ? '#d32f2f' : 'inherit', paddingBottom: '8px', fontFamily: "Inter", fontWeight: "500", width: '100%' }}>
                        Know Your Role
                    </span>}
                    key="1"
                >
                    <KnowYourRole />
                </TabPane>
                <TabPane
                    tab={<span style={{
                        color: activeTab === '2' ? '#d32f2f' : 'inherit', paddingBottom: '8px', fontFamily: "Inter", fontWeight: "500"
                    }}>
                        Stars
                    </span >}
                    key="2"
                >
                    <AdminStars />
                </TabPane >
                <TabPane
                    tab={<span style={{ color: activeTab === '3' ? '#d32f2f' : 'inherit', paddingBottom: '8px', fontFamily: "Inter", fontWeight: "500" }}>
                        Content Library
                    </span >}
                    key="3"
                >
                    <AdminContentLibrary />
                </TabPane >
                <TabPane
                    tab={<span style={{ color: activeTab === '4' ? '#d32f2f' : 'inherit', paddingBottom: '8px', fontFamily: "Inter", fontWeight: "500" }}>
                        Product Updates
                    </span >}
                    key="4"
                >
                    <ProductUpdatesAdmin />
                </TabPane >
            </Tabs >
        </div >
    );
};

export default AdminKnowYourTabs;